<template>
  <div class="root">
    <div class="share-tip" v-show="showTip" @click="closeTip()"></div>
    <span class="loading" v-show="!isShowBtn">收信中...</span>
    <CanvasToImg class="canvas-img" :texts = texts :imgNum = imgNum animate="fadeIn" @loaded="showBtn()"> </CanvasToImg>
    <div :class="[{'over-layer':!wideScreen},{'over-layer-wide':wideScreen}]" v-show="isShowBtn" ></div>
   <!-- <div :class="[{'share':!wideScreen},{'share-wide':wideScreen}]" v-show="isShowBtn" @click="toShare()"></div>-->
    <div :class="[{'explain':!wideScreen},{'explain-wide':wideScreen}]" v-show="isShowBtn" @click="toExplain()"></div>
    <div class="share-hand" v-show="showTip" @click="closeTip()"></div>
  </div>
</template>

<script>

export default {
  name: 'Result',
  data () {
    return {
      texts: [
      ],
      imgNum: 2,
      showTip: false,
      isShowBtn: false,
      wideScreen: true
    }
  },
  mounted() {
    const width = document.documentElement.clientWidth || window.innerWidth
    const height = document.documentElement.clientHeight || window.innerHeight
    // 判断屏幕的尺寸，以决定canvas生成的图片会被怎样裁剪，然后调整覆盖层的样式
    if ((width / height) < (375 / 667)) {
      this.wideScreen = false
    }
  },
  created() {
    let name = this.$route.query.name || '你'
    let len = name.replace(/[^\x00-\xff]/ig, '**').length
    let flag = false
    while (len > 10) {
      flag = true
      name = name.slice(0, -1)
      len = name.replace(/[^\x00-\xff]/ig, '**').length
    }
    if(flag){
      name = name + '...'
      len = name.replace(/[^\x00-\xff]/ig, '**').length
    }
    const fz = 29 - Math.floor(len/2)
    const x = len > 10 ? 520 - len * fz : 320 - (len>=5 ? len/2:len*0.5) * fz
    const nameObj = {
      content: name,
      x,
      y: 398,
      fz,
      color: '#3c3c3c'
    }
    this.texts.push(nameObj)
  },
  methods: {
    toShare() {
      this.showTip = true
      setTimeout(() => this.showTip = false, 2000)
    },
    closeTip(){
      this.showTip = false
    },
    toExplain() {
      // 路由传递文章id和宽屏幕的标识
      this.$router.push(`/explain?article=${this.$route.query.article}&wide=${+this.wideScreen}`)
    },
    showBtn() {
      this.isShowBtn = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .root{
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url("../assets/result/bg.png");
  }
  .share-tip{
    color: white;
    position: absolute;
    background-color: black;
    opacity: .4;
    z-index: 99;
    width: 100%;
    height: 100%;
    font-size: 14px;
    top:0;
    left:0;
  }
  .canvas-img{
    width: 100%;

  }
  .share{
    position: absolute;
    bottom: calc(50% - 50vw*667/375 + 45vw);
    left:34vw;
    width: 24vw;
    height: 11vw;
    //border: black 1px solid;
  }
  .share-hand{
    position: absolute;
    width:40.5vw;
    height: 62.4vw;
    top:2px;
    right:0;
    background: url("../assets/result/share_hand.png") center no-repeat;
    background-size: contain;
    z-index: 999;
    opacity: 1;
  }
  .explain{
    position: absolute;
    bottom: calc(50% - 50vw*667/375 + 46vw);
    right:33vw;
    width: 24vw;
    height: 11vw;
    //border: black 1px solid;
  }
  .over-layer{
    position: absolute;
    bottom: calc(50% - 50vw*667/375 + 40vw);
    right: 23vw;
    width: 42.7vw;
    height: 16.6vw;
    //border: red 1px solid;
    background: url("../assets/result/layer.png") center no-repeat;
    background-size: contain;
    animation: fadeIn 1s both;
  }
  .over-layer-wide{
    position: absolute;
    bottom: calc(50% - 50vw*667/375 + 40vw);
    right:calc(50% - 50vh*375/667 + 18vh);
    width: 14.16vh;
    height: 9.12vh;
    background: url("../assets/result/layer.png") center no-repeat;
    background-size: contain;
    animation: fadeIn 1s both;
  }
  .explain-wide{
    position: absolute;
    bottom: calc(50% - 50vw*667/375 + 45vw);
    right:calc(50% - 50vh*375/667 + 18vh);
    width: 14vh;
    height: 5vh;
    //border: red 1px solid;
  }
  .share-wide{
    position: absolute;
    bottom: 25%;
    right:calc(50% - 50vh*375/667 + 23.5vh);
    width: 13vh;
    height: 5vh;
    //border: red 1px solid;
  }
  .loading{
    font-size: 3rem;
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Result.vue